/**
 * `localeTag` — map the project's UI language (`fi` / `en` / `sv`) to the BCP 47
 * tag used for `Intl.DateTimeFormat` (and any other locale-sensitive formatter).
 *
 * The intended single source of truth for member-facing date formatting, so
 * surfaces don't hand-roll the ternary (which had drifted — Swedish was falling
 * back to `fi-FI`). Swedish uses `sv-FI` (Finland-Swedish) — the defensible
 * choice for a Finnish fund. NOTE: adoption is not yet app-wide — e.g.
 * `my-data/AnalyticsDataSection` still hand-rolls `sv → 'sv-SE'` and others
 * (`InvoiceCard`, `MyDataSection`, `profile/formatIsoDate`) still fall Swedish
 * back to `fi-FI`. Consolidating them onto this helper and picking ONE canonical
 * Swedish tag is a separate app-wide cleanup, tracked in
 * `specs/030-member-messaging-integration/tasks.md` T026 (owner: web/i18n).
 */

import type { LanguageCode } from './LanguagePort.js';

export function localeTag(active: LanguageCode): string {
  switch (active) {
    case 'en':
      return 'en-GB';
    case 'sv':
      return 'sv-FI';
    default:
      return 'fi-FI';
  }
}
